// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__sppp8","col":"styles_col__2fsUH","fulfillmentStatus":"styles_fulfillmentStatus__3-ZJW","emailCol":"styles_emailCol__npnT3"};